import { Environment, environment } from '@repo/environment';

export const formatUrl = (address: string, protocol: string = 'https'): string => {
  if (/^https?:\/\//.test(address)) {
    return address;
  }
  if (environment === Environment.LOCAL) {
    return `http://${address}`;
  }

  return `${protocol}://${address}`;
};
